import './Skeleton.react.scss';

const Skeleton = ({ height, width, className }) => (
  <div className={`skeleton ${className}`} style={{ height: height, width: width }} />
);

export default Skeleton;
